<div class="center-xy"
     [ngStyle]="{ overflow: zones.overflow ? 'auto' : 'hidden'}"
     *ngIf="zones.selectedZone">
    <div class="zone-control-wrapper bg-light" data-testid="schedule-list-control">
        <div class="zone-control__top">
            <div class="zone-control__top-icon bg-style bg-style__icon border-light">
                <zone-icon [name]="zones.selectedZone.description.styleIcon" [size]="45"></zone-icon>
            </div>
            <p class="zone-control__top-name font-bold font-24 bg-style bg-style__label color-light">
                {{ zones.getZoneName(zones.selectedZone) }}
            </p>
        </div>

        <div class="zone-control__content">
            <div class="zone-control__buttons-top">
                <div class="zone-control__close-button cursor-pointer bg-cancel bg-cancel__button"
                     data-testid="go-back-icon"
                     (click)="zones.goBack()">
                    <img ngSrc="/assets/img/zone_icons/back_without_border.svg"
                         width="40" height="40" alt=""/>
                </div>
            </div>

            <div class="zone-control__schedule-list" *ngIf="schedules.length === 5">
                <div class="zone-control__schedule-item cursor-pointer font-18 font-bold"
                     [ngClass]="{ 'bg-style color-light': zones.selectedZone.mode.mode === 'localSchedule'
                        || zones.selectedZone.mode.scheduleIndex === -1,
                        'color-basic bg-settings bg-settings--zone': !(zones.selectedZone.mode.mode === 'localSchedule'
                            || zones.selectedZone.mode.scheduleIndex === -1) }"
                     (click)="zoneSchedule.showFirstInterval=false;
                         zoneSchedule.showSecondInterval=false;
                         zoneSchedule.setSchedule(zones.selectedZone.schedule);">
                    <img class="zone-control__schedule-item-icon"
                         ngSrc="/assets/img/zone_icons/checked.svg"
                         *ngIf="zones.selectedZone.mode.mode === 'localSchedule'
                            || zones.selectedZone.mode.scheduleIndex === -1"
                         width="25" height="25" alt=""/>
                    <p>{{ subtitle(1682) }}</p>
                </div>
                <div class="zone-control__schedule-item cursor-pointer font-18 font-bold"
                     *ngFor="let schedule of schedules"
                     [ngClass]="{ 'bg-style color-light': zones.selectedZone.mode.scheduleIndex === schedule.index
                        && zones.selectedZone.mode.mode !== 'localSchedule',
                        'color-basic bg-settings bg-settings--zone': !(zones.selectedZone.mode.scheduleIndex === schedule.index
                            && zones.selectedZone.mode.mode !== 'localSchedule') }"
                     (click)="zoneSchedule.showFirstInterval=false;
                        zoneSchedule.showSecondInterval=false;
                        zoneSchedule.setSchedule(schedule)">
                    <img class="zone-control__schedule-item-icon"
                         ngSrc="/assets/img/zone_icons/checked.svg"
                         *ngIf="zones.selectedZone.mode.scheduleIndex === schedule.index
                            && zones.selectedZone.mode.mode !== 'localSchedule'"
                         width="25" height="25" alt=""/>
                    <p>
                        {{ zones.getScheduleName(schedule.index, 'long') }}
                    </p>
                </div>
            </div>
            <div class="zone-control__schedule-list" *ngIf="schedules.length === 0">
                <div class="zone-control__schedule-item cursor-pointer font-18 font-bold"
                     [ngClass]="{ 'bg-style color-light': zones.selectedZone.mode.mode == 'localSchedule'
                        || zones.selectedZone.mode.scheduleIndex === -1,
                        'color-basic bg-settings': !( zones.selectedZone.mode.mode == 'localSchedule'
                            || zones.selectedZone.mode.scheduleIndex === -1) }"
                     (click)="zoneSchedule.showFirstInterval=false;
                        zoneSchedule.showSecondInterval=false;
                         zoneSchedule.setSchedule(zones.selectedZone.schedule);">
                    <img class="zone-control__schedule-item-icon"
                         ngSrc="/assets/img/zone_icons/checked.svg"
                         *ngIf="zones.selectedZone.mode.mode === 'localSchedule'
                            || zones.selectedZone.mode.scheduleIndex == -1"
                         width="25" height="25" alt=""/>
                    <p>{{ subtitle(1682) }}</p>
                </div>
            </div>
            <div class="zone__info zone__info--schedules"
                 *ngIf="schedules.length < 5 && schedules.length !== 0">
                <p class="zone__info-name bg-style color-light">
                    {{ subtitle(3162) + '...' }}
                </p>
            </div>
        </div>
    </div>
</div>
